module.exports = __webpack_public_path__ + "img/logotype.4e9c8f2c.png";